import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class PcbMappingService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                public fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.PCB_MAPPINGS(), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.PCB_MAPPINGS_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.PCB_MAPPINGS(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.PCB_MAPPINGS(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.PCB_MAPPINGS(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.PCB_MAPPINGS_STATUS(id), data);
    }

    getByLanding(id, data): Observable<any> {
        return this.getRequest(AppUrl.PCB_MAPPINGS_BY_LANDING(id), data);

    }

    createByAdmin(id, data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITY_PCB_MAPPINGS(id), data);
    }

    getByAdmin(id, data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_PCB_MAPPINGS(id), data);
    }

    getCourseByLanding(id, data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_PCB_MAPPINGS_COURSES(id), data);
    }

    getBranchByLanding(id, data): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITY_PCB_MAPPINGS_BRANCHES(id), data);
    }

    updateByAdmin(universityId, id, data): Observable<any> {
        return this.putRequest(AppUrl.PCB_MAPPINGS_UPDATE_BY_ADMIN(universityId, id), data);
    }

    updateFeeStructureByAdmin(universityId, data): Observable<any> {
        return this.putRequest(AppUrl.PCB_MAPPINGS_FEE_STRUCTURE_BY_ADMIN(universityId), data);
    }

    updateStatusByAdmin(universityId, id, data): Observable<any> {
        return this.putRequest(AppUrl.PCB_MAPPINGS_STATUS_UPDATE_BY_ADMIN(universityId, id), data);
    }

    detailByAdmin(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITY_PCB_MAPPINGS(id));
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }
}
